import type { LatitudeLongitude } from "@freightsimple/generated-dashboard-openapi-client/models/LatitudeLongitude";

export function latitudeLongitudeToNumbers(
  coordinates: Required<LatitudeLongitude>,
): [number, number] {
  return [coordinates.longitude, coordinates.latitude];
}
